// extracted by mini-css-extract-plugin
module.exports = {"accountIconArea":"PostComment_accountIconArea_3RhKa","btnTextStyle":"PostComment_btnTextStyle_2g2hz","currentAccountIcon":"PostComment_currentAccountIcon_37tl4"};